import { useLocalSearchParams } from "expo-router";
import React, { createContext, ReactNode, useContext, useState } from "react";

type ChatContextType = {
  selectedChatId: string | null;
  setSelectedChatId: React.Dispatch<React.SetStateAction<string | null>>;
};

const ChatContext = createContext<ChatContextType | undefined>(undefined);

type ChatProviderProps = {
  children: ReactNode;
  initialChatId?: string | null;
};

export const ChatProvider = ({
  children,
  initialChatId,
}: ChatProviderProps) => {
  const params = useLocalSearchParams<{ chatId?: string }>();
  const [selectedChatId, setSelectedChatId] = useState<string | null>(
    initialChatId ?? params.chatId ?? null,
  );
  return (
    <ChatContext.Provider value={{ selectedChatId, setSelectedChatId }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChatContext must be used within a ChatProvider");
  }
  return context;
};
